import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { ProposalService } from '../services/sections/job/proposal.service';
import { BriefComment } from '../models/brief-comment.model';

@Injectable({
	providedIn: 'root'
})
export class ProposalCustomerThreadResolver implements Resolve<Observable<BriefComment[]>> {

	constructor(
		private router: Router,
		private proposalService: ProposalService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.proposalService.getCustomerComments(activatedRouteSnapshot.paramMap.get('token'), parseInt(activatedRouteSnapshot.paramMap.get('proposalId'), 10))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
